module.exports = __webpack_public_path__ + "models/antenna_4cc76744ff5cb8196390768722f14d95.glb";